import React, { Component } from 'react';
import { Data } from '../../../shared/Types';

import './FormCard.scss';

export default class FormCard extends Component<Data> {
  constructor(props: Data) {
    super(props);
  }

  render() {
    const { lastname, firstname, male, country, date, imageSrc } = this.props;
    return (
      <div className="card form-card" data-testid="form-card">
        <div className="card__avatar">
          <img src={imageSrc} alt="avatar image" className="card__avatar-img" />
        </div>
        <div className="form-card__content">
          <h5>Firstname: {firstname}</h5>
          <h5>Lastname: {lastname}</h5>
          <h6>Country: {country}</h6>
          <h6>Birth: {date}</h6>
          <h6>Male: {male}</h6>
        </div>
      </div>
    );
  }
}
